export const USER_FIRST_NAME_PLACEHOLDER = "xx";
export const USER_LAST_NAME_PLACEHOLDER = "xx";
